module.exports = __webpack_public_path__ + "fonts/encode.2fe37d6e.ttf";